import { createSlice } from "@reduxjs/toolkit";

import type { NotificationsState } from "../../../../../components/NotificationAlerts/types";
import { NotificationType } from "../../../../../components/NotificationAlerts/types";

export const initialState: NotificationsState = {
    show: false,
    title: null,
    titleKey: null,
    text: null,
    textKey: null,
    type: null,
    isCloseable: true,
    data: {},
};

export const notificationsState = createSlice({
    name: "NotificationsSlice",
    initialState,
    reducers: {
        //  By default, notification can be closed manually by user and is closed automatically after 5 seconds (DEFAULT_AUTO_CLOSE_MS).
        //  If this or other notification action is called multiple times, then only content from last action is displayed.
        //  Multiple notifications are not currently supported.
        showNotification: (_draft, action) => ({
            ...initialState,
            show: true,
            ...action.payload,
        }),
        showSuccessNotification: (_draft, action) => ({
            ...initialState,
            show: true,
            type: NotificationType.SUCCESS,
            titleKey: "core.notifications.success.title",
            ...action.payload,
        }),
        showInfoNotification: (_draft, action) => ({
            ...initialState,
            show: true,
            type: NotificationType.INFO,
            titleKey: "core.notifications.info.title",
            ...action.payload,
        }),
        showWarningNotification: (_draft, action) => ({
            ...initialState,
            show: true,
            type: NotificationType.WARNING,
            titleKey: "core.notifications.warning.title",
            ...action.payload,
        }),
        showErrorNotification: (_draft, action) => ({
            ...initialState,
            show: true,
            type: NotificationType.ERROR,
            titleKey: "core.notifications.error.title",
            ...action.payload,
        }),
        // Hides currently displayed notification or does nothing if there is no notification displayed.
        hideNotification: () => initialState,
    },
});

export const {
    showNotification,
    showSuccessNotification,
    showWarningNotification,
    showInfoNotification,
    showErrorNotification,
    hideNotification,
} = notificationsState.actions;
